// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.import-export h3{font-family:unset;text-transform:none}`, "",{"version":3,"sources":["webpack://./src/react/components/SystemSetup/ImportExport/ImportExport.css"],"names":[],"mappings":"AAAA,kBACE,iBAAA,CACA,mBAAA","sourcesContent":[".import-export h3 {\n  font-family: unset;\n  text-transform: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
